import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { configurationApi, type SecretRecord } from '../../api/configuration';

export function SecretVaultPage() {
  const [secrets, setSecrets] = useState<SecretRecord[]>([]);
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  function load() {
    void configurationApi.listSecrets().then((r) => setSecrets(r.secrets)).catch((e) => setError(String(e)));
  }

  useEffect(() => { load(); }, []);

  async function handleCreate(e: React.FormEvent) {
    e.preventDefault();
    try {
      await configurationApi.createSecret({ key, value });
      setKey('');
      setValue('');
      load();
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/configuration" className="text-sm text-blue-600 hover:underline">← Configuration Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Secret Vault</h1>
      <form onSubmit={(e) => void handleCreate(e)} className="mt-4 flex flex-wrap gap-2">
        <input value={key} onChange={(e) => setKey(e.target.value)} placeholder="secret key" className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" required />
        <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="secret value" type="password" className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" required />
        <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white">Store / Rotate</button>
      </form>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-2">
        {secrets.map((s) => (
          <li key={s.id} className="rounded border px-4 py-3 dark:border-slate-700">
            <span className="font-mono">{s.key}</span> — v{s.version} · {s.active ? 'active' : 'inactive'}
          </li>
        ))}
      </ul>
    </div>
  );
}
